/**
 * 内容类型定义
 * 支持文章、视频、图片、音频、文档等多种类型
 */

export const contentTypes = {
  article: {
    id: 'article',
    name: '文章',
    icon: 'file-text',
    color: '#3B82F6',
    platforms: ['微信公众号', '知乎', '掘金', 'Medium', '简书', '博客']
  },
  video: {
    id: 'video',
    name: '视频',
    icon: 'play-circle',
    color: '#EF4444',
    platforms: ['YouTube', 'B站', '抖音', '西瓜视频', 'Vimeo']
  },
  image: {
    id: 'image',
    name: '图片',
    icon: 'image',
    color: '#10B981',
    platforms: ['Unsplash', 'Pinterest', 'Dribbble', '花瓣']
  },
  audio: {
    id: 'audio',
    name: '音频',
    icon: 'headphones',
    color: '#F59E0B',
    platforms: ['播客', '网易云音乐', '喜马拉雅', 'Spotify']
  },
  document: {
    id: 'document',
    name: '文档',
    icon: 'file',
    color: '#8B5CF6',
    platforms: ['PDF', 'Notion', '语雀', '飞书文档']
  },
  code: {
    id: 'code',
    name: '代码',
    icon: 'code',
    color: '#06B6D4',
    platforms: ['GitHub', 'GitLab', 'CodePen', 'Gist']
  },
  tweet: {
    id: 'tweet',
    name: '推文',
    icon: 'message-circle',
    color: '#1DA1F2',
    platforms: ['Twitter', '微博', '即刻']
  },
  other: {
    id: 'other',
    name: '其他',
    icon: 'link',
    color: '#64748B',
    platforms: []
  }
}

// URL模式匹配规则，用于自动识别内容类型
export const urlPatterns = [
  // 视频平台
  { pattern: /youtube\.com|youtu\.be/i, type: 'video', platform: 'YouTube' },
  { pattern: /bilibili\.com|b23\.tv/i, type: 'video', platform: 'B站' },
  { pattern: /douyin\.com|tiktok\.com/i, type: 'video', platform: '抖音' },
  { pattern: /vimeo\.com/i, type: 'video', platform: 'Vimeo' },
  
  // 文章平台
  { pattern: /mp\.weixin\.qq\.com/i, type: 'article', platform: '微信公众号' },
  { pattern: /zhihu\.com\/p\//i, type: 'article', platform: '知乎' },
  { pattern: /juejin\.cn\/post/i, type: 'article', platform: '掘金' },
  { pattern: /medium\.com/i, type: 'article', platform: 'Medium' },
  { pattern: /jianshu\.com\/p/i, type: 'article', platform: '简书' },
  
  // 代码平台
  { pattern: /github\.com\/[\w-]+\/[\w-]+/i, type: 'code', platform: 'GitHub' },
  { pattern: /gitlab\.com/i, type: 'code', platform: 'GitLab' },
  { pattern: /codepen\.io/i, type: 'code', platform: 'CodePen' },
  { pattern: /gist\.github\.com/i, type: 'code', platform: 'Gist' },
  
  // 图片平台
  { pattern: /unsplash\.com/i, type: 'image', platform: 'Unsplash' },
  { pattern: /pinterest\.com/i, type: 'image', platform: 'Pinterest' },
  { pattern: /dribbble\.com/i, type: 'image', platform: 'Dribbble' },
  
  // 社交平台
  { pattern: /twitter\.com|x\.com/i, type: 'tweet', platform: 'Twitter' },
  { pattern: /weibo\.com/i, type: 'tweet', platform: '微博' },
  
  // 文档平台
  { pattern: /notion\.so/i, type: 'document', platform: 'Notion' },
  { pattern: /yuque\.com/i, type: 'document', platform: '语雀' },
  { pattern: /\.pdf$/i, type: 'document', platform: 'PDF' },
  
  // 音频平台
  { pattern: /music\.163\.com/i, type: 'audio', platform: '网易云音乐' },
  { pattern: /ximalaya\.com/i, type: 'audio', platform: '喜马拉雅' },
  { pattern: /spotify\.com/i, type: 'audio', platform: 'Spotify' }
]

// 根据URL识别内容类型
export function detectContentType(url) {
  for (const rule of urlPatterns) {
    if (rule.pattern.test(url)) {
      return {
        type: rule.type,
        platform: rule.platform
      }
    }
  }
  return { type: 'other', platform: null }
}

// 根据文件扩展名识别类型
export function detectTypeByExtension(url) {
  const imageExts = /\.(jpg|jpeg|png|gif|webp|svg|bmp)$/i
  const videoExts = /\.(mp4|webm|mov|avi|mkv)$/i
  const audioExts = /\.(mp3|wav|ogg|flac|aac)$/i
  const docExts = /\.(pdf|doc|docx|ppt|pptx|xls|xlsx)$/i
  
  if (imageExts.test(url)) return 'image'
  if (videoExts.test(url)) return 'video'
  if (audioExts.test(url)) return 'audio'
  if (docExts.test(url)) return 'document'
  
  return null
}
